/**
 * InTouchApp Phone Contacts & Data Saver
 *
 * Exposes a large static WAR group (contact-modal templates plus fonts and vendor
 * images) with no `use_dynamic_url`, but scopes its `matches` to intouchapp.com,
 * linkedin.com, facebook.com, whatsapp.com and google.com. So the resources load at a
 * fixed URL, yet only those origins can reach them — we probe from the vendor's own
 * intouchapp.com, where a negative is meaningful.
 *
 * Manifest verified against version 4.56.0.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'fmanjoeogdemcgapfmadpgcmigkefkkc';

export const intouchapp: ExtensionDefinition = {
  id: ID,
  name: 'InTouchApp Phone Contacts & Data Saver',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 40_000,
  requiredOrigin: 'https://www.intouchapp.com',
  notes:
    'Static templates and vendor images scoped to a handful of origins (intouchapp.com, ' +
    'linkedin, facebook, whatsapp, google). Detectable only from those sites.',
  signals: [
    {
      id: 'war-addcontact-modal-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch templates/int_addcontactModal.html — a vendor-named contact-modal ' +
        'template exposed to the scoped origins.',
      weight: 1,
      run: () => probeFetch(ID, 'templates/int_addcontactModal.html'),
    },
    {
      id: 'war-ita-logo-svg',
      kind: 'web-accessible-resource',
      description:
        'Fetch assets/images/ita_logo.svg — the vendor logo, an independent second path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'assets/images/ita_logo.svg'),
    },
    {
      id: 'war-onboarding-html',
      kind: 'web-accessible-resource',
      description: 'Fetch templates/custom/ita_onboarding.html — a third origin-scoped path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'templates/custom/ita_onboarding.html'),
    },
  ],
};
